import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import decodedUserDetails from "../../utils/decodedUserDetails";
import { URL_ORDERING_PRACTITIONERS } from "config/connString";

const getOrderingPractitionersLookup = createAsyncThunk(
  "ordering-practitioners/get-ordering-practitioners-look-up",
  async () => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const api = useAxios();
      const config = {
        params: {
          clientId: clientId,
          search: "",
          pageSize: 90,
          pageNumber: 1,
        },
      };
      const response = await api.get(
        URL_ORDERING_PRACTITIONERS + "/ordering-practitioners-lookup",
        config
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getOrderingPractitionersLookup };
